export default __webpack_public_path__ + "static/media/legal-obligation-accordion.783f46f1.md";